const PUSH_NOTIFICATIONS_OPT_IN_KEY = "push_notifications_opt_in_v1";

export function getStoredPushNotificationOptIn(
  defaultValue = true,
): boolean {
  if (typeof window === "undefined") return defaultValue;
  try {
    const value = window.localStorage.getItem(PUSH_NOTIFICATIONS_OPT_IN_KEY);
    if (value === "true") return true;
    if (value === "false") return false;
    return defaultValue;
  } catch {
    return defaultValue;
  }
}

export function setStoredPushNotificationOptIn(enabled: boolean): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(
      PUSH_NOTIFICATIONS_OPT_IN_KEY,
      enabled ? "true" : "false",
    );
  } catch {
    // ignore
  }
}

export function clearStoredPushNotificationOptIn(): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(PUSH_NOTIFICATIONS_OPT_IN_KEY);
  } catch {
    // ignore
  }
}
